var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesPie = function SvgIconsChartTypesPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.197 3.3a.91.91 0 0 1-.47 1.197 8.184 8.184 0 0 0 2.216 15.615 8.181 8.181 0 0 0 8.592-4.927.909.909 0 1 1 1.675.708 10 10 0 0 1-19.11-2.49A10.002 10.002 0 0 1 8 2.83c.46-.201.997.009 1.197.47zM12 2a9.998 9.998 0 0 1 10 10.002.91.91 0 0 1-.803.903l-.106.006H12a.91.91 0 0 1-.904-.803l-.006-.106V2.909a.91.91 0 0 1 .91-.909zm.909 1.87v7.223h7.22l-.024-.213a8.185 8.185 0 0 0-1.912-4.226l-.211-.235-.196-.204a8.181 8.181 0 0 0-4.355-2.27l-.309-.05-.213-.026z"
  }))));
};
export default SvgIconsChartTypesPie;